import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
*{
    margin:0;
    padding: 0;
    box-sizing: border-box;
}
body{
    background-color: #282C4B;
    overflow-x: hidden;
}`;

export default GlobalStyles;